// ─────────────────────── Company mapping ────────────────────────────────

export const COMPANY_ORDER = ["蚂蚁集团", "京东", "腾讯", "美团", "字节跳动"];

export const PRODUCT_TO_COMPANY: Record<string, string> = {
  "花呗": "蚂蚁集团", "借呗": "蚂蚁集团", "网商贷": "蚂蚁集团",
  "白条": "京东", "金条": "京东", "京小贷": "京东",
  "微粒贷": "腾讯", "分付": "腾讯",
  "美团借钱": "美团", "美团生意贷": "美团", "美团月付": "美团",
  "抖音月付": "字节跳动", "放心借": "字节跳动", "放心生意贷": "字节跳动",
};

export const COMPANY_DOT_COLOR: Record<string, string> = {
  "蚂蚁集团": "bg-blue-500", "京东": "bg-red-500", "腾讯": "bg-green-500",
  "美团": "bg-yellow-400", "字节跳动": "bg-zinc-800",
};

// ─────────────────────── Source badge ───────────────────────────────────

export const SOURCE_BADGE: Record<string, { label: string; cls: string }> = {
  xiaohongshu: { label: "红", cls: "bg-red-500 text-white" },
  weibo:       { label: "微", cls: "bg-orange-500 text-white" },
  heimaotousu: { label: "黑", cls: "bg-zinc-700 text-white" },
};

// ─────────────────────── Sentiment meta ────────────────────────────────

export const SENT_META: Record<string, { dot: string; badge: string; label: string }> = {
  positive: { dot: "bg-emerald-500", badge: "border border-emerald-200/70 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300", label: "正面" },
  negative: { dot: "bg-rose-500", badge: "border border-rose-200/70 bg-rose-50 text-rose-700 dark:border-rose-800 dark:bg-rose-900/20 dark:text-rose-300", label: "负面" },
  neutral: { dot: "bg-zinc-400", badge: "border border-zinc-200/70 bg-zinc-100/80 text-zinc-600 dark:border-zinc-800 dark:bg-zinc-900/30 dark:text-zinc-300", label: "中性" },
};

// ─────────────────────── Impact meta ───────────────────────────────────

export const IMPACT_META: Record<string, { dot: string; badge: string; label: string }> = {
  high:   { dot: "bg-rose-500", badge: "border border-rose-200/70 bg-rose-50 text-rose-700 dark:border-rose-800 dark:bg-rose-900/20 dark:text-rose-300", label: "高影响" },
  medium: { dot: "bg-amber-500", badge: "border border-amber-200/70 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-300", label: "中影响" },
  low:    { dot: "bg-emerald-500", badge: "border border-emerald-200/70 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300", label: "低影响" },
};

// ─────────────────────── Trend meta ────────────────────────────────────

export const TREND_META: Record<string, { label: string; cls: string }> = {
  rising:    { label: "↑ 上升", cls: "text-rose-600 dark:text-rose-400" },
  stable:    { label: "→ 稳定", cls: "text-ink-tertiary" },
  declining: { label: "↓ 下降", cls: "text-emerald-600 dark:text-emerald-400" },
};

// ─────────────────────── Issue type meta ───────────────────────────────

export const ISSUE_TYPE_META: Record<string, { label: string; cls: string }> = {
  "逾期协商": { label: "逾期", cls: "border border-red-200/70 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-900/20 dark:text-red-300" },
  "利率费率争议": { label: "费率", cls: "border border-amber-200/70 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-300" },
  "额度变动": { label: "额度", cls: "border border-slate-200/70 bg-slate-50 text-slate-600 dark:border-slate-800 dark:bg-slate-900/20 dark:text-slate-300" },
  "还款故障": { label: "还款", cls: "border border-rose-200/70 bg-rose-50 text-rose-700 dark:border-rose-800 dark:bg-rose-900/20 dark:text-rose-300" },
  "催收投诉": { label: "催收", cls: "border border-stone-200/70 bg-stone-50 text-stone-700 dark:border-stone-800 dark:bg-stone-900/20 dark:text-stone-300" },
  "开通注销": { label: "开通", cls: "border border-zinc-200/70 bg-zinc-50 text-zinc-600 dark:border-zinc-800 dark:bg-zinc-900/20 dark:text-zinc-300" },
  "隐私安全": { label: "隐私", cls: "border border-orange-200/70 bg-orange-50 text-orange-700 dark:border-orange-800 dark:bg-orange-900/20 dark:text-orange-300" },
  "征信问题": { label: "征信", cls: "border border-border bg-surface-sunken text-ink-secondary dark:border-zinc-800 dark:bg-zinc-900/20 dark:text-zinc-300" },
  "营销误导": { label: "营销", cls: "border border-border bg-surface-sunken text-ink-secondary dark:border-zinc-800 dark:bg-zinc-900/20 dark:text-zinc-300" },
  "正面体验": { label: "好评", cls: "border border-emerald-200/70 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300" },
  "产品对比": { label: "对比", cls: "border border-border bg-surface-sunken text-ink-secondary dark:border-zinc-800 dark:bg-zinc-900/20 dark:text-zinc-300" },
  "使用攻略": { label: "攻略", cls: "border border-border bg-surface-sunken text-ink-tertiary dark:border-zinc-800 dark:bg-zinc-900/20 dark:text-zinc-400" },
  "产品迭代": { label: "迭代", cls: "border border-border-strong bg-surface-sunken text-ink font-semibold dark:border-zinc-700 dark:bg-zinc-900/30 dark:text-zinc-200" },
};

// ─────────────────────── Emotion intensity ─────────────────────────────

export const EMOTION_META: Record<string, { label: string; cls: string }> = {
  mild:     { label: "平和", cls: "text-ink-faint" },
  moderate: { label: "不满", cls: "text-warning dark:text-warning-dark" },
  strong:   { label: "强烈", cls: "text-negative dark:text-negative-dark" },
  extreme:  { label: "极端", cls: "text-negative dark:text-negative-dark font-bold" },
};

// ─────────────────────── Risk helpers ──────────────────────────────────

export interface RiskLevel {
  text: string;
  bg: string;
  dot: string;
  label: string;
}

export function riskColor(index: number): RiskLevel {
  if (index >= 60) return { text: "text-rose-700 dark:text-rose-300", bg: "border border-rose-200/70 bg-rose-50 dark:border-rose-800 dark:bg-rose-900/20", dot: "bg-rose-500", label: "高风险" };
  if (index >= 30) return { text: "text-amber-700 dark:text-amber-300", bg: "border border-amber-200/70 bg-amber-50 dark:border-amber-800 dark:bg-amber-900/20", dot: "bg-amber-500", label: "中风险" };
  return { text: "text-emerald-700 dark:text-emerald-300", bg: "border border-emerald-200/70 bg-emerald-50 dark:border-emerald-800 dark:bg-emerald-900/20", dot: "bg-emerald-500", label: "低风险" };
}

// ─────────────────────── Formatting ────────────────────────────────────

export function fmtCount(n?: number): string {
  if (!n || n <= 0) return "";
  if (n >= 10000) return (n / 10000).toFixed(1).replace(/\.0$/, "") + "万";
  return String(n);
}

export function toDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function defaultRange() {
  const to = new Date(), from = new Date();
  from.setDate(from.getDate() - 29);
  return { from: toDateStr(from), to: toDateStr(to) };
}

// ─────────────────────── Grouping ──────────────────────────────────────

import type { ProductSentiment } from "../../api";

export function groupByCompany(products: ProductSentiment[]) {
  const map = new Map<string, ProductSentiment[]>();
  for (const p of products) {
    const c = PRODUCT_TO_COMPANY[p.product] ?? p.company ?? "其他";
    if (!map.has(c)) map.set(c, []);
    map.get(c)!.push(p);
  }
  const result: Array<{ company: string; items: ProductSentiment[] }> = [];
  for (const c of COMPANY_ORDER) if (map.has(c)) result.push({ company: c, items: map.get(c)! });
  for (const [c, items] of map) if (!COMPANY_ORDER.includes(c)) result.push({ company: c, items });
  return result;
}
